@use "../../styles/breakpoint.module.scss" as *;

.valueProp {
    @media ($above-tablet) {
        position: absolute;
        top: var(--top);
        width: var(--width);
    }
}

.alignLeft {
    composes: valueProp;

    @media ($above-tablet) {
        --content-width: calc(var(--width) - var(--hotspot-left-offset));

        left: 0;
    }
}

.alignRight {
    composes: valueProp;

    @media ($above-tablet) {
        --content-width: calc(var(--width) - var(--hotspot-right-offset));

        right: 0;
    }
}

.hidden {
    @media ($above-tablet) {
        visibility: hidden;
        pointer-events: none;
    }
}

.inner {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    @media ($above-tablet) {
        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 2px;
            background-color: var(--robins-blue);
        }

        &::after {
            content: "";
            position: absolute;
            top: var(--vertical-pointer-line-height-offset);
            left: 0;
            width: 2px;
            height: var(--vertical-pointer-line-height);
            background-color: var(--robins-blue);
        }

        .alignLeft & {
            align-items: flex-start;

            .valuePropTitle {
                flex-direction: row-reverse;
            }
        }

        .alignRight & {
            align-items: flex-end;
            text-align: right;
        }
    }
}

.colliding {
    @media ($above-tablet) {
        .inner {
            transform: translateY(var(--translate-y));
        }
    }
}

.contents {
    --title-gap: var(--spacer-12);

    display: flex;
    flex-direction: column;
    gap: var(--spacer-8);
    padding-top: 16px;

    @media ($above-tablet) {
        // value prop contents shouldn't be wider than this, but they can be
        // set to be narrower to prevent content overlapping the image
        max-width: 300px;
        width: var(--content-width);

        .overLine & {
            transform: translateY(-100%);
            padding-top: 0;
            padding-bottom: var(--spacer-16);
        }
    }
}

.contentsWithIcon {
    composes: contents;
    gap: var(--spacer-4);

    --svg-size: 48px;

    @media ($below-tablet) {
        --svg-size: 40px;

        gap: 0;
    }
}

.valuePropTitle {
    display: flex;
    gap: var(--title-gap);
    align-items: center;
    font: var(--font-h-20);

    svg {
        width: var(--svg-size);
        height: var(--svg-size);
    }

    @media ($above-tablet) {
        justify-content: flex-end;
    }

    @media ($below-tablet) {
        height: var(--svg-size, auto);

        :global(.imageDataWrapper) {
            width: var(--svg-size);
            height: var(--svg-size);
            order: 0;
        }

        .titleNumber {
            order: 1;
            max-width: 1ch;
        }

        .titleSpan {
            order: 2;
        }
    }
}

.titleNumber {
    @media ($above-tablet) {
        display: none;
    }
}

.body {
    @media ($below-tablet) {
        padding-left: calc(var(--svg-size) + var(--title-gap));
    }
}

.hiddenBody {
    composes: body;

    @media ($above-tablet) {
        opacity: 0;
    }
}
